import { useEffect, useState } from "react";
import { useBrandDeals } from "../../../../Providers/Deals";
import { MdOpenInNew, MdOutlineLock } from "react-icons/md";
import mixpanel from "mixpanel-browser";
import { useAuth } from "@/Providers/Auth";
import { HiArrowNarrowRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { BsFire } from "react-icons/bs";

import { Button } from "@/shadcnComponents/ui/button";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

const NoDealsMessages = [
  "No deals, no worries! Keep your eyes peeled for upcoming exclusives.",
  "Stay tuned! Our brand partners are gearing up to surprise you with exciting offers.",
  "The calm before the storm! Deals are brewing, so don't stray too far.",
  "We're preparing a feast of deals for you. In the meantime, give your public profile max exposure!",
  "No deals at the moment, but we're cooking up something special!",
  "Emptiness now, excitement later! Deals inbound, stay tuned.",
  "The void of deals won't last forever! Check back soon for fresh offers.",
];

export const BrandDeals = () => {
  const [AllDeals, setAllDeals] = useState([]);
  const BrandDealsState = useBrandDeals();
  const authstate = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const getAllplans = async () => {
      const result = await BrandDealsState?.getActiveBrandDeals();
      if (result?.success) {
        setAllDeals(result?.resolvedActiveDeals);
      }
    };
    getAllplans();
  }, []);

  const getDate = (date) => {
    const d = new Date(date);

    const newDate = d.toDateString().split(" ");

    return (
      // newDate[0] + " | " + newDate[1] + " " + newDate[2] + " " + newDate[3]
      newDate[2] + " " + newDate[1] + " " + newDate[3]
    );
  };
  return (
    <>
      <MobileMenuBar />
      <div className="w-full font-inter px-10 py-5 box-border flex items-center justify-between h-max ">
        <section className="flex flex-col gap-[10px]  w-full">
          <span className="text-[16px] md:text-[24px] font-[700] text-[#FFFFFF]  ">
            Brand Deals
          </span>
          <span className=" text-[#A3A3A3] text-[14px] md:text-[16px] font-[400]  ">
            Find all the brands looking to collaborate with you!
          </span>
          {AllDeals?.length > 0 ? (
            <section className="w-full flex flex-wrap justify-center md:justify-start gap-5 mb-20 mt-5 ">
              {AllDeals?.map((item, index) => {
                const visible =
                  item?.minchips <= authstate?.loggedUser?.totalChips &&
                  (item?.profileVisible
                    ? authstate?.loggedUser?.activePlan
                    : true);
                const isExpired =
                  new Date(item?.Deadline) < new Date(Date.now());
                return (
                  <div
                    className=" w-[282px] flex items-center justify-between flex-col rounded-[10px] gap-[12px]  bg-[#212121] p-[20px] shadow-[0px_0px_8px_0px_rgba(136,136,136,0.08)] leading-[normal] rounded-[10px]"
                    key={index}
                  >
                    <div
                      className={`w-[40px] h-[40px] rounded-full overflow-hidden ${
                        visible || isExpired ? "" : "blur-sm"
                      } `}
                    >
                      <img
                        src={
                          visible || isExpired
                            ? item?.companyLogo
                            : "https://anchors-assets.s3.amazonaws.com/1712228438331-screenshot-20240404-144153.png"
                        }
                        alt=""
                      />
                    </div>
                    <span
                      className={`text-center text-[12px] font-[700] text-[#EEEEEE] uppercase ${
                        visible || isExpired ? "" : "blur-sm"
                      }`}
                    >
                      {visible || isExpired
                        ? item?.companyName
                        : "Company Name"}
                    </span>
                    {visible ||
                      (isExpired && (
                        <div
                          onClick={() => {
                            if (!/^https?:\/\//i.test(item?.websiteLink)) {
                              const profileLink =
                                "https://" + item?.websiteLink;
                              return window.open(profileLink, "_blank");
                            }

                            window.open(item?.websiteLink, "_blank");
                          }}
                          className=" inline-flex items-center gap-2.5 px-2 py-1 rounded-[6px]  cursor-pointer border border-[color:var(--Natural-800,#424242)] rounded-md border-solid"
                        >
                          <span className="flex gap-[12px] items-center text-[color:var(--Secondary-200,#8EA7EC)] text-xs not-italic font-normal leading-[normal]">
                            {item?.websiteLink} <MdOpenInNew size={12} />{" "}
                          </span>
                        </div>
                      ))}
                    {visible ||
                      (isExpired && (
                        <div className=" inline-flex items-center gap-1 px-2 py-1 border border-[color:var(--Natural-800,#424242)] rounded-md border-solid">
                          <span className="flex flex-wrap justify-center items-center gap-[10px] text-[12px] font-[400] text-[#FF5C5C] ">
                            Campaign Goals:
                            {item?.campaignGoal?.map((item, index) => {
                              return (
                                <span className="text-[#EEEEEE] " key={index}>
                                  {item}
                                </span>
                              );
                            })}
                          </span>
                        </div>
                      ))}
                    <div
                      className={`w-full inline-flex flex-col justify-center items-center gap-1 border border-[color:var(--Natural-800,#424242)] px-3 py-2 rounded-lg border-solid ${
                        visible ? "" : "bg-[#424242] "
                      } `}
                    >
                      {visible || isExpired ? (
                        <div className="inline-flex flex-col justify-center items-center gap-1 px-3 py-2 rounded-lg border-solid">
                          <span className="flex text-[12px] font-[500] text-[#FF5C5C] ">
                            Eligibility Criteria
                          </span>
                          <span className="text-[12px] text-wrap font-[500] text-[#E0E0E0] ">
                            LinkedIn Followers: &gt; {item?.minFollower}
                          </span>
                          <span className="text-[12px] text-wrap font-[500] text-[#E0E0E0] ">
                            Past Collaborations: &gt; {item?.minCollab}
                          </span>
                        </div>
                      ) : (
                        <div
                          className="w-full inline-flex flex-col justify-center text-[#FFFFFF] items-center gap-1 px-3 py-2 rounded-lg rounded-[10px];
                      "
                        >
                          <MdOutlineLock size={24} />
                          <span className=" text-[12px] font-[700] uppercase text-[#FFFFFF] ">
                            To Unlock this deal
                          </span>
                          <ul
                            className="flex flex-col items-start justify-center text-[12px] tesxt-[#FFFFFF] font-[400]"
                            style={{ listStyle: "disc" }}
                          >
                            <li>
                              Minimum {item?.minchips} Chips needed <br />{" "}
                              <span
                                onClick={() =>
                                  navigate("/influencer/build_profile?page=1")
                                }
                                className="flex items-center gap-1 text-[#8EA7EC] underline cursor-pointer"
                              >
                                Earn more chips <HiArrowNarrowRight size={12} />
                              </span>{" "}
                            </li>

                            {item?.profileVisible ||
                              (isExpired && (
                                <li>
                                  Profile should be visible
                                  <span
                                    onClick={() =>
                                      navigate("/influencer/payment")
                                    }
                                    className="flex items-center gap-1 text-[#8EA7EC] underline cursor-pointer"
                                  >
                                    Publish profile{" "}
                                    <HiArrowNarrowRight size={12} />
                                  </span>{" "}
                                </li>
                              ))}
                          </ul>
                        </div>
                      )}
                    </div>
                    <div
                      className={`mt-[20px] ${
                        visible || isExpired ? "" : "blur-sm"
                      } `}
                    >
                      <Button
                        className="flex gap-[3px] w-full bg-[#DC2627] hover:bg-[#FF5C5C] "
                        onClick={
                          visible && !isExpired
                            ? () => {
                                mixpanel.track(`Brand deals express interest`, {
                                  companyName: item?.companyName,
                                });
                                if (!/^https?:\/\//i.test(item?.formLink)) {
                                  const profileLink =
                                    "https://" + item?.formLink;
                                  return window.open(profileLink, "_blank");
                                }

                                window.open(item?.formLink, "_blank");
                              }
                            : null
                        }
                      >
                        <BsFire size={16} />
                        {isExpired
                          ? "Deal Expired"
                          : "Express Interest".toLocaleUpperCase()}
                      </Button>
                      {/* <Button1

                      text={"Express Interest".toLocaleUpperCase()}
                      onClick={
                        visible
                          ? () => {
                              mixpanel.track(`Brand deals express interest`, {
                                companyName: item?.companyName,
                              });
                              if (!/^https?:\/\//i.test(item?.formLink)) {
                                const profileLink = "https://" + item?.formLink;
                                return window.open(profileLink, "_blank");
                              }

                              window.open(item?.formLink, "_blank");
                            }
                          : null
                      }
                      icon={<BsFire size={16} />}
                      rightIcon={undefined}
                      background={undefined}
                      textColor={undefined}
                      borderColor={undefined}

                    /> */}
                    </div>

                    <span className="text-[12px] text-wrap font-[400] text-[#FF5C5C]">
                      Deadline : {getDate(item?.Deadline)}
                    </span>
                  </div>
                );
              })}
            </section>
          ) : (
            <section className="w-full h-[60vh] flex items-center justify-center ">
              <span className="text-[#757575] text-[16px] md:text-[24px] font-[700]">
                {NoDealsMessages[Math.floor(Math.random() * 6 + 1)]}
              </span>
            </section>
          )}
        </section>
      </div>
    </>
  );
};
